import React, { useState } from 'react';
import styles from './DENTMedicalExaminationsAlert.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import DENTMedicalExaminationsAlertEvents from './DENTMedicalExaminationsAlertEvents';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import { UpcomingExaminationEvent } from '../../Interfaces/medicalExamination/UpcomingExaminationEvent.interface';
import { useUpdateDentMedicalExaminationMutation } from '../../../../graphql/graphql';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { useDENTContext } from '../../Services/DENTContext';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	events: UpcomingExaminationEvent[];
	onClose: () => void;
}

const DENTMedicalExaminationsAlert = ({ events, onClose }: Props) => {
	const [selectedEvent, setSelectedEvent] =
		useState<UpcomingExaminationEvent>();
	const [updateMedicalExamination] = useUpdateDentMedicalExaminationMutation();
	const { displayGQLError } = useApiClient();
	const {
		setActiveMedicalExaminationId,
		setMedicalExaminationNotificationShown,
	} = useDENTContext();
	const { showNotificationSuccess } = useNotification();

	const handleSubmit = async () => {
		const medicalExaminationId = selectedEvent?.extra?.medicalExaminationId;

		if (medicalExaminationId) {
			const response = await updateMedicalExamination({
				input: { startedAt: new Date() },
				where: { id: medicalExaminationId },
			});

			if ('data' in response) {
				showNotificationSuccess({
					content:
						'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.startSuccess',
				});
				setMedicalExaminationNotificationShown(true);
				setActiveMedicalExaminationId(medicalExaminationId);
				onClose();
			} else {
				displayGQLError(response);
				setActiveMedicalExaminationId(undefined);
			}
		}
	};

	return (
		<div className={styles.wrapper}>
			<Text tx='patientTreatment.meddiDENT.dentalCross.upcomingExamination.text' />
			<DENTMedicalExaminationsAlertEvents
				events={events}
				selectedEvent={selectedEvent}
				onSelectEvent={setSelectedEvent}
			/>
			<div className={styles.buttonWrapper}>
				<Button
					title={
						'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.start'
					}
					theme={Theme.GREEN}
					onClick={handleSubmit}
					disabled={!selectedEvent}
				/>
			</div>
		</div>
	);
};

export default DENTMedicalExaminationsAlert;
